import {
  IUserPreferencesService,
  IUserService,
} from "@/application/abstractions/user/user-service.interface";
import {
  UserApiRepository,
  UserPreferencesApiRepository,
} from "@/infrastructure/repositories/api/users/user-api.repository";
import { servicesErrorHandler } from "../service-error-handler";
import {
  CreateUserPreferencesError,
  DeleteUserPreferencesError,
  GetUserError,
  GetUserPreferencesError,
  PasswordResetError,
  PasswordResetTriggerError,
  UpdateUserError,
  UpdateUserPreferencesError,
} from "@/domain/errors/users";

const UserAppServices: IUserService = {
  async getCurrent() {
    try {
      return await UserApiRepository.getCurrent();
    } catch (error: unknown) {
      throw servicesErrorHandler(error, new GetUserError());
    }
  },

  async getByID(id) {
    try {
      return await UserApiRepository.getByID(id);
    } catch (error) {
      throw servicesErrorHandler(error, new GetUserError());
    }
  },

  async updateByID({ id, userData }) {
    try {
      await UserApiRepository.updateByID(id, userData);
    } catch (error) {
      throw servicesErrorHandler(error, new UpdateUserError());
    }
  },

  async triggerPasswordReset(email) {
    try {
      await UserApiRepository.triggerReset(email);
    } catch (error) {
      throw servicesErrorHandler(error, new PasswordResetTriggerError());
    }
  },

  async resetPassword(data) {
    try {
      await UserApiRepository.resetPassword(data);
    } catch (error) {
      throw servicesErrorHandler(error, new PasswordResetError());
    }
  },
};

const UserPreferencesAppServices: IUserPreferencesService = {
  async getByUserID(userID) {
    try {
      return await UserPreferencesApiRepository.getByUserID(userID);
    } catch (error) {
      throw servicesErrorHandler(error, new GetUserPreferencesError());
    }
  },

  async create(preferences) {
    try {
      await UserPreferencesApiRepository.create(preferences);
    } catch (error) {
      throw servicesErrorHandler(error, new CreateUserPreferencesError());
    }
  },

  async deleteByID(ID) {
    try {
      await UserPreferencesApiRepository.deleteByID(ID);
    } catch (error) {
      throw servicesErrorHandler(error, new DeleteUserPreferencesError());
    }
  },

  async updateByID({ ID, preferences }) {
    try {
      await UserPreferencesApiRepository.updateByID(ID, preferences);
    } catch (error) {
      throw servicesErrorHandler(error, new UpdateUserPreferencesError());
    }
  },
};

export { UserAppServices, UserPreferencesAppServices };
